// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"eM","newsTag":"eM","dafalut":"eN","qishou":"eO","shangjia":"eP","shehui":"eQ","caiwu":"eR","piyao":"eS","suanfa":"eT","keji":"eU","lingshou":"eV","gongzuo":"eW"};